export const API_AUTH_URL = process.env.REACT_APP_AUTHURL;